import { VanillaReaderUiDialog } from "../VanillaReaderUI/VanillaReaderUiDialog";

export class MasterPlanUiStart extends VanillaReaderUiDialog<void> {

    private _bodyStyle = `
    <style>      
        #vanilla-reader__masterplan-start[role=dialog] {  
            padding: 0!important;
            top: 0!important;
            bottom: 0!important;
            right: 0!important;
            left: 0!important;
            height: 100%!important;
            width: 100%!important;
            max-width: initial!important;
            border-radius: 0!important;
            border: 0!important;
        }
        #vanilla-reader__masterplan-start .vanilla-reader-ui__dialog__header {
            display: none !important;
        }
        #vanilla-reader__masterplan-start .vanilla-reader-ui__dialog__body {
            flex-grow: 2;
            margin: 16px;
            margin-top: 0;
            margin-bottom: 0;
            overflow: hidden;
            overflow-y: auto;
            display:flex;
            align-items: center;

        }
        #vanilla-reader__masterplan-start .vanilla-reader-ui__dialog__header__close-button {
            display: none;
        }

        #vanilla-reader__masterplan-start .masterplan-logo {
            max-height: 50vh;
            min-height: 300px;
            width: 100%;
            background-image: url("https://masterplan.circularsoftware.com/img/MasterPlan_Light.png");
            background-size:contain;
            background-repeat: no-repeat;
            background-position: center;
            cursor:pointer;
        }

        @media only screen and (max-device-width: 480px) {         
            #vanilla-reader__masterplan-start .vanilla-reader-ui__dialog__body {
                margin: 8px;
            }
            
            .vanilla-reader__card {
               padding: 8px;
               box-shadow: none;             
            }
        }
    </style>`;
    private _bodyTemplate = ``;
    

    constructor(
        _hostElement: HTMLElement,
        insertPosition: InsertPosition = 'afterbegin'
    ) {
        super(_hostElement, 'vanilla-reader__masterplan-start', '', insertPosition);

        this._dialogBodyElement.innerHTML = this._bodyTemplate;
        this._dialogElement.insertAdjacentHTML('afterbegin', this._bodyStyle);
        this._dialogBodyElement.innerHTML = `
            <div class="masterplan-logo"></div> 
        `;
        document.querySelector(".masterplan-logo")!.addEventListener('click', this._event_logoClicked);
    }

    private _event_logoClicked = (_ev: Event) => {
        window.open("https://www.circularsoftware.com/masterplan/");
    };
}